import { useState, useEffect } from "react";
import axios from "axios";
import { Alert, Modal, Col, Row, Form, Button } from "react-bootstrap";

const UpdateAikikaiModal = (props) => {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");

  const [isLoading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [idAikikai, setIdAikikai] = useState("");
  const [dateAikikai, setDateAikikai] = useState("");

  const exam = props.exam;
  const token = JSON.parse(ls.get("jwt"));

  var moment = require("moment");
  const displayDateFormat = "DD/MM/YYYY";

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function isIncomplete() {
    return !idAikikai || idAikikai === "" || !dateAikikai || dateAikikai === "";
  }

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  function GetError(error) {
    return error.response
      ? "ERROR: " + error.response.data?.error?.message
      : "ERROR: " + error.mesage;
  }

  const handleSubmit = async (e) => {
    setLoading(true);
    setErrorMessage(null);
    e.preventDefault();

    let isError = false;
    /* consultar el user con los datos de examenes, 
         buscar el examen a procesar y lo actualiza
      */
    const u = await axios
      .get(`${API_URL}/users/${exam.userId}`, headerRequest)
      .catch((error) => {
        isError = true;
        setErrorMessage(GetError(error));
      });

    // DEPRECATED: se hace en server
    // await axios
    //   .get(
    //     `${API_URL}/users?filters[exams][grade][id][$eq]=${exam.gradeId}&populate=exams.grade&pagination[pageSize]=2000`,
    //     headerRequest
    //   )
    //   .then((users) => {
    //     let exams = [];
    //     for (let i = 0; i < users.data.length; i++) {
    //       const u = users.data[i];
    //       if (u.exams?.length) {
    //         for (let j = 0; j < u.exams.length; j++) {
    //           const e = u.exams[j];
    //           if (e.grade?.id && e.grade?.id == exam.gradeId && e.idAikikai) {
    //             let x = {
    //               id: e.idAikikai,
    //               date: e.dateAikikai,
    //               examId: e.id,
    //               userId: u.id,
    //               userDoc: u.docNumber,
    //             };
    //             exams.push(x);
    //           }
    //         }
    //       }
    //     }
    //     exams.sort(function (a, b) {
    //       return moment(a.date).toDate() - moment(b.date).toDate();
    //     });

    //     const examsBefore = exams.filter(
    //       (e) =>
    //         moment(dateAikikai, true).diff(moment(e.date, true), "days") > 0
    //     );
    //     const examsAfter = exams.filter(
    //       (e) =>
    //         moment(dateAikikai, true).diff(moment(e.date, true), "days") < 0
    //     );

    //     const minId =
    //       examsBefore.length === 0
    //         ? 0
    //         : parseInt(examsBefore[examsBefore.length - 1].id);

    //     const maxId =
    //       examsAfter.length === 0 ? minId + 25000 : parseInt(examsAfter[0].id);

    //     const newId = parseInt(idAikikai);
    //     if (newId <= minId || newId >= maxId) {
    //       isError = true;
    //       setErrorMessage(
    //         `Error en Registered No, rango permitido de ${minId} a ${maxId}`
    //       );
    //     }
    //   })
    //   .catch((error) => {
    //     isError = true;
    //     setErrorMessage(GetError(error));
    //   });

    if (!isError) {
      let reqUser = u.data;
      let userExams = reqUser.exams;

      const examToUpdateIdx = userExams.findIndex((e) => {
        if (e.grade.id == exam.gradeId) {
          return true;
        }
        return false;
      });

      if (examToUpdateIdx >= 0) {
        userExams[examToUpdateIdx].dateAikikai = dateAikikai;
        userExams[examToUpdateIdx].idAikikai = idAikikai;
      }
      reqUser.exams = userExams;

      await axios
        .put(`${API_URL}/users/${exam.userId}`, reqUser, headerRequest)
        .then(() => {
          setLoading(false);
          props.onHide(true);
        })
        .catch((error) => {
          console.log("Error with put users:", error.response);
          setErrorMessage(GetError(error));
        });
    }
    setLoading(false);
  };

  return (
    <Modal
      {...props}
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Editar Exámen
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="show-grid">
        <Form onSubmit={(e) => handleSubmit(e)}>
          <Row className="mb-1">
            <h5>Datos del Alumno</h5>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="formDocNumber">
              <Form.Label>Núm. Documento</Form.Label>
              <Form.Control readOnly value={exam.docNumber} />
            </Form.Group>
            <Form.Group as={Col} controlId="formLastname">
              <Form.Label>Nombre</Form.Label>
              <Form.Control readOnly value={exam.fullname} />
            </Form.Group>
          </Row>
          <hr />
          <Row className="mb-1">
            <h5>Datos del Exámen</h5>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="formGrade">
              <Form.Label>Graduación aprobada</Form.Label>
              <Form.Control readOnly value={exam.grade} />
            </Form.Group>

            <Form.Group as={Col} controlId="formBirthDate">
              <Form.Label>Fecha de Examen</Form.Label>
              <Form.Control
                readOnly
                value={moment(exam.date).format(displayDateFormat)}
              />
            </Form.Group>
          </Row>

          <Row className="mb-1">
            <h6>Datos de la Yudansha</h6>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="formGrade">
              <Form.Label>Registered No</Form.Label>
              <Form.Control
                type="text"
                placeholder="Número de registro"
                value={idAikikai}
                inputMode="numeric"
                pattern="[0-9]*"
                onChange={(e) => setIdAikikai(e.target.value)}
              />
            </Form.Group>

            <Form.Group as={Col} controlId="formBirthDate">
              <Form.Label>Date Aikikai</Form.Label>
              <Form.Control
                type="date"
                name="dateAikikai"
                value={dateAikikai}
                onChange={(e) => setDateAikikai(e.target.value)}
              />
            </Form.Group>
          </Row>
          <Button
            variant="primary"
            type="submit"
            disabled={isLoading || isIncomplete()}
          >
            {isLoading ? "Procesando…" : "GRABAR"}
          </Button>
          {errorMessage ? (
            <Alert className="mt-3" variant="danger">
              {errorMessage}
            </Alert>
          ) : (
            <></>
          )}
        </Form>
      </Modal.Body>
    </Modal>
  );
};
export default UpdateAikikaiModal;
